import { useAppContext } from "contexts";
import { HouseGameType } from "helpers/constants";
import { useMemo } from "react";
import { IWGameItem } from "types/games";

export default function useGetWGames() {
  const { isFeatureEnabled } = useAppContext();
  const WGames = useMemo<IWGameItem[]>(() => {
    return [
      {
        title: "plinko",
        imageSrc: "/images/gamesComponent/plinko.png",
        link: "/games/plinko",
        disabled: false,
        code: HouseGameType.PLINKO,
      },
      {
        title: "mines",
        imageSrc: "/images/gamesComponent/mines.png",
        link: "/games/mines",
        disabled: false,
        code: HouseGameType.MINES,
      },
      {
        title: "roulette",
        imageSrc: "/images/gamesComponent/roulette.png",
        link: "/games/roulette",
        disabled: false,
        code: HouseGameType.ROULETTE,
      },
      {
        title: "blackjack",
        imageSrc: "/images/gamesComponent/blackjack.png",
        link: "/games/blackjack",
        disabled: false,
        code: HouseGameType.BLACKJACK,
      },
      {
        title: "crash",
        imageSrc: "/images/gamesComponent/crash.png",
        link: "/games/crash",
        disabled: isFeatureEnabled("ALLOW_CRASH_GAMES") === false,
        code: HouseGameType.CRASH,
      },
      {
        title: "coinflip",
        imageSrc: "/images/gamesComponent/coinflip.png",
        link: "/games/coinflip",
        disabled: false,
        code: HouseGameType.COINFLIP,
      },
      {
        title: "keno",
        imageSrc: "/images/gamesComponent/keno.png",
        link: "/games/keno",
        disabled: isFeatureEnabled("ALLOW_KENO_GAMES") === false,
        code: HouseGameType.KENO,
      },
    ];
  }, [isFeatureEnabled]);

  return { WGames };
}
